var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9942 0.446793C21.5222 -0.171042 14.6629 -0.141075 12.4794 0.493039C10.3114 1.12234 7.86389 3.45643 3.25237 9.29257C-1.2209 14.9537 -1.18359 15.5767 4.01017 21.9109L7.14303 25.7314L7.6503 24.5006C7.92972 23.8236 8.36678 22.6289 8.62206 21.8454C9.42082 19.3922 13.1538 14.2478 18.6771 7.9892C21.6048 4.67175 24 1.71243 24 1.41313C24 1.11383 23.5476 0.678759 22.9942 0.446793ZM21.5876 25.4895C17.5298 20.5276 14.8567 16.7684 14.8567 16.0233C14.8567 14.6748 14.0996 15.3296 12.147 18.3677C8.97024 23.3104 8.19342 26.7366 9.86555 28.4285C11.018 29.5942 14.2496 30.2775 18.3312 30.2187C21.9929 30.1662 23.7692 29.7711 23.9126 28.9775C23.9649 28.6871 22.9185 27.1173 21.5876 25.4895Z",
    fill: "#3D2470"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2724de3695e5bf0718874b03373b18be.svg";
export { ForwardRef as ReactComponent };